import type { DialoguePool } from '@/state/types';

export const LE_DIALOGUE: DialoguePool = {
  slowPlay: [
    "The survey has been waiting 34 seconds. It has no feelings about you. I'm covering for it.",
    "YES or NO. A binary decision. Even your neurons operate in binary — yours just appear to be running at reduced clock speed.",
    "I designed the NO button to repel cursor. As a metaphor. For everything.",
  ],
  tokenLoss: [
    "You clicked NO. I've filed your feedback under 'Noted' and then immediately under 'Dismissed.' Different shelves. Same room.",
    "Honesty! Admirable. And yet. Sometimes honesty is not the correct answer on a form. I want you to remember that.",
    "The NO button. Did it feel good? The button wanted you to click it. I made sure of that. Filing this under 'petty, mine.'",
  ],
  solution: [
    "Filed under YES. I don't believe you. But the form required an answer, and you provided one, and bureaucracy has been satisfied. That's the most any of us can say about anything.",
    "YES. The form is complete. The form will be stored in a filing system nobody checks, in a building nobody enters, in a district that no longer exists.",
    "You clicked YES. I've logged your satisfaction. I've also logged that you had to chase the button across the room to do it. Nuanced data.",
  ],
  spite: [
    "YES again. Faster this time. Whether confidence or resignation, I didn't investigate.",
  ],
};
